import {State} from "./types";
import {storage} from "../../../utils/storage";
import {userInitialState} from "global/initial-states";

export const initialState: State = {
  isLogged: !!storage["read"]("[user]"),
  user: storage["read"]("[user]") || userInitialState,
};
